/* @img-migrated */
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

import Img from '../../components/Img';
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          const userData = await exchangeSession(sessionId);
          toast.success('Welcome! Signed in with Google.');
          // Staff roles go to admin, members (including leadership) go to portal
          const isStaffAdmin = ['super_admin', 'membership_lead', 'marketing_team'].includes(userData.role);
          navigate(isStaffAdmin ? '/admin' : '/portal', { replace: true, state: { user: userData } });
        } catch (error) {
          toast.error('Authentication failed. Please try again.');
          navigate('/member-login', { replace: true });
        }
      } else {
        navigate('/member-login', { replace: true });
      }
    };

    processCallback();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#002249]" data-testid="auth-callback">
      <div className="text-center">
        <Img variant="generic"
          src="/brand/logo-color-alt.png"
          alt="DCCF"
          className="h-20 mx-auto mb-8"
        />
        <div className="flex items-center justify-center space-x-2">
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <p className="text-white/80 mt-4">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
